<template>
  <div class="productProcess">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.FabricReport.DATA_MEASUREMENT_FIELD_TEST') }}
    </div>
    <div class="productProcess-list" v-for="(item, index) in data" :key="index">
      <!-- <div class="button-group">
        <a-button type="primary" size="small" @click="saveProductProcess(item)"
          >保存</a-button
        >
      </div> -->
      <div class="dian1">
        <span>{{ $tc('lang.FabricReport.Test_Item') }}：</span>
        <a-input v-model="item.testitems.testitemField"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.FabricReport.Dye_Lot') }}：</span>
        <a-input v-model="item.testitems.testitenDyelot"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.FabricReport.Roll_Number') }}：</span>
        <a-input v-model="item.testitems.testitenRollnumber"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.FabricReport.Date_Records') }}：</span>
        <a-input v-model="item.testitems.testitemNotes"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.FabricReport.Conclusion') }}：</span>
        <a-radio-group
          name="radioGroup"
          v-model="item.testitems.testitemConclude"
        >
          <a-radio value="1">{{ $tc('lang.FabricReport.yes') }}</a-radio>
          <a-radio value="3">{{ $tc('lang.FabricReport.no') }}</a-radio>
          <!-- <a-radio value="3">次要</a-radio> -->
        </a-radio-group>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.FabricReport.Remarks') }}：</span>
        <a-input v-model="item.testitems.testitemRemarks"></a-input>
      </div>
      <div class="desOfGoods-con">
        <span>{{ $tc('lang.FabricReport.Test') }}</span>
        <div class="img">
          <show-img
            :data="item.media"
            :otherData="{
              mediaName: '',
              mediaType: 3,
              personId: '',
              orderId: '',
              reportId: '',
              mediaDesc: '',
            }"
            :id="id"
          ></show-img>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import showImg from './showImg';
export default {
  data() {
    return {
      data: [],
      id: this.$route.query.id,
    };
  },
  computed: {
    fabricDetails: {
      get() {
        return JSON.parse(
          JSON.stringify(this.$store.state.report.fabricDetails),
        );
      },
    },
  },
  components: {
    showImg,
  },
  created() {
    this.getSelectDate();
  },
  methods: {
    //获取数据
    getSelectDate() {
      this.$http
        .post('/hzwmj/fabric-testitem/seachFabricTestitem', {
          reportId: this.fabricDetails.freportId,
          // reportNo: this.details.ireportId,
        })
        .then(data => {
          if (data) {
            data.data.forEach(item => {
              if (item.media == null) {
                item.media = [];
              }
            });
            this.data = data.data;
          } else {
            this.data = [];
          }
        })
        .catch(() => {
          this.data = [];
        });
    },
    //保存
    saveProductProcess(value) {
      let list = [];
      let imgList = [];
      value.media.forEach(item => {
        imgList.push(item.id);
      });

      const testitems = value.testitems;
      list.push({
        ...testitems,
        modelType: '6',
        testitemPhoto: imgList.join(','),
      });
      this.$http
        .post('/hzwmj/fabric-testitem/saveOrUpdateFabricTestitem', {
          data: list,
        })
        .then(data => {
          if (data) {
            this.$message.success('保存成功');
            this.getSelectDate();
          } else {
            this.$message.error('保存失败');
          }
        })
        .catch(() => {
          this.$message.error('保存失败');
        });
    },
    deleteImg(id) {
      this.$http
        .post('/hzwmj/inspect-defect/delectInspectDefect', {
          id: id,
        })
        .then(data => {
          if (data) {
            this.$message.success('删除成功');
            this.getSelectDate();
          } else {
            this.$message.error('删除失败');
          }
        })
        .catch(() => {
          this.$message.error('删除失败');
        });
    },
    cancel() {},
  },
};
</script>
<style lang="less">
.productProcess {
  .productProcess-list {
    margin-bottom: 20px;
  }
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
      // text-align: center;
    }
    // img {
    //   width: 20%;
    //   height: 150px;
    //   margin: 0 20px 20px;
    // }
  }
  .dian1 {
    margin-bottom: 10px;
    > span:nth-child(1) {
      width: 120px;
      padding-left: 20px;
      display: inline-block;
    }
    input {
      width: 150px;
    }
    .ant-radio-group {
      width: 220px;
    }
  }
}
</style>
